import MilitaryInfoComponent from './MilitaryInfoContainer';

export default MilitaryInfoComponent;